import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { dataExportStore } from 'App/data-export/store/dataExportStore'

export const logAnyDataDiscrepancies = (data: routes.Values.Response) => {
  const discrepancies = new Set<string>()
  const intervalRequested = dataExportStore.getState().formState.interval

  Object.entries(data).forEach(([, assetValues]) => {
    Object.entries(assetValues ?? {}).forEach(([, { values }]) => {
      Object.entries(values ?? {}).forEach(([valueType, items]) => {
        // @ts-expect-error
        items?.forEach((item) => {
          if (item.metadata.aggregationInterval !== intervalRequested) {
            discrepancies.add(
              `'${intervalRequested}' requested for '${valueType}' but received '${item.metadata.aggregationInterval}'`,
            )
          }
        })
      })
    })
  })

  if (discrepancies.size) {
    // eslint-disable-next-line no-console
    console.warn(discrepancies)
  }
}
